export function scrollTop () {
  // We use this in Onboarding wizard and Settings page to be sure the substep header is never hidden.
  // We have to use a negative y position to make sure to scroll above the adress bar,
  // which is not included in the viewport height
  // We also need a setTimeout to make it work on iOS
  setTimeout(() => window.scrollTo(0, -100), 0)
}
